'use client';

import { PriceFrequency } from '@energy-retailer/constants';

import { RadioButtonVariant, RadioField } from '@/components/input';
import { Text } from '@/components/text';

import type { FilteringSchemaType } from './form-schema';
import type { ComponentProps } from 'react';
import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { ANALYTICS_EVENTS } from '@/constants';

const priceFrequencyOptions: { id: PriceFrequency; name: string }[] = [
  {
    id: PriceFrequency.Yearly,
    name: 'Yearly',
  },

  {
    id: PriceFrequency.Quarterly,
    name: 'Quarterly',
  },
  {
    id: PriceFrequency.Monthly,
    name: 'Monthly',
  },
  {
    id: PriceFrequency.Weekly,
    name: 'Weekly',
  },
];

type EstimatedPriceFieldProps = {
  labelVariant?: ComponentProps<typeof Text>['variant'];
  labelAs?: ComponentProps<typeof Text>['as'];
};

const onPreferenceChanged = (value: PriceFrequency) => {
  switch (value) {
    case PriceFrequency.Yearly:
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.estimatedPrice.yearly, {})
      break;
    case PriceFrequency.Quarterly:
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.estimatedPrice.quarterly, {})
      break;
    case PriceFrequency.Monthly:
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.estimatedPrice.monthly, {})
      break;
    case PriceFrequency.Weekly:
      trackAnalyticsEvent(ANALYTICS_EVENTS.compareEnergyPlans.estimatedPrice.weekly, {})
      break;
    default:
      break;
  }
}

const PriceFrequencyField = ({
  labelVariant = 'h3',
  labelAs = 'h3',
}: EstimatedPriceFieldProps) => (
  <>
    <Text
      variant={labelVariant}
      as={labelAs}
    >
      Estimated price
    </Text>
    <RadioField<FilteringSchemaType>
      name="priceFrequency"
      variant={RadioButtonVariant.RIGHT}
      options={priceFrequencyOptions}
      defaultValue={PriceFrequency.Yearly}
      onOptionChange={onPreferenceChanged}
    />
  </>
);

export { PriceFrequencyField };
